import {useState} from "react"
// @mui
import { styled } from '@mui/material/styles';
import { Card, Container, Typography } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Page from '../components/Page';

// sections
import { LoginForm } from '../sections/auth/login';

  

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
 
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');

  return (
    <Page title="Login">
      <RootStyle>
        <HeaderStyle>
        
        </HeaderStyle>

        {mdUp && (
          <SectionStyle>
            <Typography variant="h3" sx={{ px: 5}}>
             Bienvenue ! 
            </Typography>
            <img src={`${process.env.REACT_APP_BASEURL}${process.env.REACT_APP_CUSTOMERLOGO}`} alt="login" />
            <div style={{marginTop: 'auto', textAlign: 'center', width: '100%', paddingTop: 24}}>
              <p style={{fontSize: '0.85rem', color: '#888'}}>propulsé par</p>
              <img src="/static/logo.svg" alt="Sherlook" style={{width: 90, margin: '8px auto'}} />
              <p style={{fontSize: '0.75rem', color: '#aaa'}}>tous droits réservés 2025</p>
            </div>
          </SectionStyle>
        )}

        <Container maxWidth="sm">
          <ContentStyle>
            <Typography variant="h4" gutterBottom>
             Connectez vous avec vos identifiants
            </Typography>

          

           

            <LoginForm />

          
            
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
